export default __webpack_public_path__ + "static/media/contestRes.a75ef936.svg";